import './App.css';
import './Dropdown/Dropdown.css';
import './Browser.css';
import { BrowserRouter, Route, Routes, Link, useLocation } from 'react-router-dom';


import Home from './sidebar/Home';
import Cliente from './sidebar/Cliente';
import Login from './sidebar/Login';
import CriarConta from './sidebar/CriarConta';
import Privacidade from './sidebar/Privacidade';
import Sidebar from './sidebar/Sidebar';

import ClientesDropdown from './Dropdown/ClientesDropdown';
import AgendamentosDropdown from './Dropdown/AgendamentosDropdown';
import CalendarioDropdown from './Dropdown/CalendarioDropdown';
import ContasPagarDropdown from './Dropdown/ContasPagarDropdown';
import ContasReceberDropdown from './Dropdown/ContasReceberDropdown';
import EntregasProdutosDropdown from './Dropdown/EntregasProdutosDropdown';
import EntregaServicosDropdown from './Dropdown/EntregaServicosDropdown';
import PrazosDropdown from './Dropdown/PrazosDropdown';
import FornecedorDropdown from './Dropdown/FornecedorDropdown';
import GarantiaDropdown from './Dropdown/GarantiaDropdown';
import NotaFiscalDropdown from './Dropdown/NotaFiscalDropdown';
import CertificadoPlugNotasDropdown from './Dropdown/CertificadoPlugNotasDropdown';
import GrupoDropDown from './Dropdown/GrupoDropDown';
import MeusGruposDropdown from './Dropdown/MeusGruposDropdown';
/* GrupoDropDown removed per user request */
import OportunidadeDropdown from './Dropdown/OportunidadeDropdown';
import OrcamentoDropdown from './Dropdown/OrcamentoDropdown';
import ProducoesDropdown from './Dropdown/ProducoesDropdown';
import DashboardProducao from './Dropdown/DashboardProducao';
import RelacionamentoClientesDropdown from './Dropdown/RelacionamentoClientesDropdown';
import ServicosTerceirosDropdown from './Dropdown/ServicosTerceirosDropdown';
import VendasDropdown from './Dropdown/VendasDropdown';
import VendasProdutosDropdown from './Dropdown/VendasProdutosDropdown';
import ProdutoDropdown from './Dropdown/ProdutoDropdown';
import DropdownComercial from './Dropdown/DropdownComercial';
import DropdownFinanceiro from './Dropdown/DropdownFinanceiro';
import DropdownEstoque from './Dropdown/DropdownEstoque';
import DropdownVendas from './Dropdown/DropdownVendas';
import ContratoDropdown from './Dropdown/ContratoDropdown';
import ProjetoVisualDropdown from './Dropdown/ProjetoVisualDropdown';
import TarefasProjetoDropdown from './Dropdown/TarefasProjetoDropdown';
import MateriaPrimaDropdown from './Dropdown/MateriaPrimaDropdown';
import ResumoResponsaveisDropdown from './Dropdown/ResumoResponsaveisDropdown';
import ResumoServicosTerceirosDropdown from './Dropdown/ResumoServicosTerceirosDropdown';
import PessoasDropdown from './Dropdown/PessoasDropdown';
import ManutencaoDropdown from './Dropdown/ManutencaoDropdown';
import EstoqueMaterialDropdown from './Dropdown/EstoqueMaterialDropdown';
import GestaoFinanceiraDropdown from './Dropdown/GestaoFinanceiraDropdown';

import AutorizarNotaIndividual from './Formulario/AutorizarNotaIndividual';
import AutorizarNotaEmMassa from './Formulario/AutorizarNotaEmMassa';
import CancelarNota from './Formulario/CancelarNota';
import EditarNota from './Formulario/EditarNota';
import AditivoContratualForm from './Formulario/AditivoContratualForm';
import AprovacaoOrcamento from './components/AprovacaoOrcamento';
import AprovacaoProjeto from './components/AprovacaoProjeto';
import CadastrarConta from './components/CadastrarConta';
import ExtratoFinanceiro from './sidebar/ExtratoFinanceiro';
import PersonalizarContrato from './sidebar/PersonalizarContrato';
import CadastrarUsuario from './components/CadastrarUsuario';
import GerenciarFuncionarios from './components/GerenciarFuncionarios';
import DadosUsuarios from './sidebar/DadosUsuarios';
import DropdownConta from './Dropdown/DropdownConta';
import MinhaConta from './sidebar/MinhaConta';
import Configuracoes from './sidebar/Configuracoes';
import AlterarSenha from './sidebar/AlterarSenha';
import EsqueceuSenha from './sidebar/EsqueceuSenha';
import Planos from './sidebar/Planos';
import Funcionario from './sidebar/Funcionario';
import MinhasConexoes from './sidebar/MinhasConexoes';
import ForumEmpresas from './components/ForumPostagem';

import React, { useState, useEffect, useRef } from 'react';
import bgHeader from './sidebar/backgroundheader.jpg';
import { isLoggedIn, getUsuarioLogado, SESSION_EXPIRED_EVENT, logout, isTokenExpired, registerActivity, checkInactivity } from './utils/auth';
import { PermissoesProvider, usePermissoes } from './utils/PermissoesContext';
import SessionExpiredPopup from './components/SessionExpiredPopup';
import InactivityWarningPopup from './components/InactivityWarningPopup';
import ChatWidget from './components/ChatWidget';
import LandingPage from './components/LandingPage';
import AjudaWidget from './components/AjudaWidget';
import MobileFooter from './components/MobileFooter';
import HomologGate from './components/HomologGate';

function AppContent() {
  return (
    <BrowserRouter>
      <AppInner />
    </BrowserRouter>
  );
}

function AppInner() {
  const location = useLocation();
  const isAprovacaoPage =
    location.pathname.startsWith('/aprovacao/') ||
    location.pathname.startsWith('/aprovacao-projeto/') ||
    location.pathname.startsWith('/aceitar-orcamento');
  // Personalizar contrato abre numa aba própria, sem header, chat, ajuda ou rodapé
  const isPersonalizarContrato = location.pathname === '/personalizar-contrato';
  // Extrato (Contas a Receber → Extrato) também abre numa aba própria
  const isExtrato = location.pathname === '/extrato';

  // Render approval page completely standalone (no header, no nav)
  if (isAprovacaoPage) {
    return (
      <Routes>
        <Route path='/aprovacao/:id' element={<AprovacaoOrcamento />} />
        <Route path='/aprovacao-projeto/:id' element={<AprovacaoProjeto />} />
        <Route path='/aceitar-orcamento' element={<AprovacaoOrcamento />} />
        <Route path='/aceitar-orcamento/:id' element={<AprovacaoOrcamento />} />
      </Routes>
    );
  }

  if (isExtrato) {
    // Só o botão de ajuda (resumo da página e chat com a IA); sem header e sem o chat da equipe
    return (
      <>
        <Routes>
          <Route path='/extrato' element={<ExtratoFinanceiro />} />
        </Routes>
        <AjudaWidget />
      </>
    );
  }

  if (isPersonalizarContrato) {
    // Só o botão de ajuda (resumo da página e chat com a IA), ao lado do Salvar; sem header e sem o chat da equipe
    return (
      <>
        <Routes>
          <Route path='/personalizar-contrato' element={<PersonalizarContrato />} />
        </Routes>
        <AjudaWidget />
      </>
    );
  }

  // Default full-app layout
  return <AppLayout />;
}

function AppLayout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [loggedIn, setLoggedIn] = useState(() => isLoggedIn());
  const [userInfo, setUserInfo] = useState(() => getUsuarioLogado());
  const [showSessionExpired, setShowSessionExpired] = useState(false);
  const [showInactivityWarning, setShowInactivityWarning] = useState(false);
  const sessionActiveRef = useRef(false);
  const location = useLocation();
  
  // Hook de permissões
  const { temPermissao, recarregarPermissoes } = usePermissoes();

  // Close mobile sidebar when route changes; also re-sync login state on navigation
  // (handles the case where Login component stores token then navigates)
  useEffect(() => {
    setMobileMenuOpen(false);
    setOpenSubmenu(null);
    const logged = isLoggedIn();
    setLoggedIn(logged);
    if (logged) setUserInfo(getUsuarioLogado());
  }, [location.pathname]);

  useEffect(() => {
    const hasStoredSession = () => {
      return Boolean(localStorage.getItem('authToken') && localStorage.getItem('userInfo'));
    };

    // Verificar status de login
    const checkLogin = () => {
      console.log('[APP] checkLogin: token no localStorage:', !!localStorage.getItem('authToken'));
      console.log('[APP] checkLogin: userInfo no localStorage:', !!localStorage.getItem('userInfo'));
      const logged = isLoggedIn();
      const user = getUsuarioLogado();
      console.log('[APP] checkLogin: isLoggedIn()=', logged, 'user=', user?.login);
      setLoggedIn(logged);
      setUserInfo(user);
      sessionActiveRef.current = logged;
      
      if (!logged) {
        // Limpa quaisquer dados de sessão antigos sem forçar popup de sessão expirada.
        logout();
        setShowSessionExpired(false);
      }
    };
    checkLogin();
    
    // Escutar evento customizado de sessão expirada
    const handleSessionExpired = () => {
      setLoggedIn(false);
      setUserInfo(null);
      setShowSessionExpired(true);
    };
    window.addEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);
    
    // Escutar mudanças no localStorage
    window.addEventListener('storage', checkLogin);
    
    // Verificar expiração do token e inatividade a cada 30 segundos
    const interval = setInterval(() => {
      const currentlyLogged = isLoggedIn();
      if (currentlyLogged) {
        if (isTokenExpired()) {
          logout();
          setLoggedIn(false);
          setUserInfo(null);
          setShowSessionExpired(true);
          sessionActiveRef.current = false;
        } else if (checkInactivity()) {
          setShowInactivityWarning(true);
        }
      } else if (sessionActiveRef.current) {
        // Sessão estava ativa no app atual, agora expirou ou foi perdida
        logout();
        setLoggedIn(false);
        setUserInfo(null);
        setShowSessionExpired(true);
        sessionActiveRef.current = false;
      } else if (hasStoredSession()) {
        // Limpa qualquer sessão antiga ou parcial quando não há usuário efetivamente logado
        logout();
        setLoggedIn(false);
        setUserInfo(null);
      }
    }, 30000);
    
    // Registrar atividade do usuário (mouse, teclado, scroll, click)
    const activityEvents = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];
    const handleActivity = () => {
      if (isLoggedIn()) {
        registerActivity();
      }
    };
    activityEvents.forEach(event => {
      window.addEventListener(event, handleActivity, { passive: true });
    });
    
    // Registrar atividade inicial somente quando estiver logado
    if (isLoggedIn()) {
      registerActivity();
    }
    
    // Recarregar permissões quando o login mudar
    recarregarPermissoes();
    
    return () => {
      window.removeEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);
      window.removeEventListener('storage', checkLogin);
      clearInterval(interval);
      activityEvents.forEach(event => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, []);

  // Handler para fechar popup e redirecionar para login
  const handleSessionExpiredClose = () => {
    setShowSessionExpired(false);
    window.location.href = '/sidebar/Login';
  };

  // Handlers para popup de inatividade
  const handleInactivityStay = () => {
    setShowInactivityWarning(false);
    registerActivity();
  };

  const handleInactivityLogout = () => {
    setShowInactivityWarning(false);
    logout();
    setLoggedIn(false);
    setUserInfo(null);
    window.location.href = '/sidebar/Login';
  };

  const toggleSubmenu = (name, e) => {
    // Only toggle submenus on touch/mobile
    if (window.innerWidth <= 768) {
      e.preventDefault();
      if (openSubmenu === name) setOpenSubmenu(null);
      else setOpenSubmenu(name);
    }
  };
  // Keep header height static; CSS `--global-header-height` defines the height

  // ── UNAUTHENTICATED LAYOUT ───────────────────────────────────────────────
  if (!loggedIn) {
    return (
      <>
        <Routes>
          <Route path='/sidebar/Login' element={<Login />} />
          <Route path='/sidebar/CriarConta' element={<CriarConta />} />
          <Route path='/sidebar/EsqueceuSenha' element={<EsqueceuSenha />} />
          <Route path='/privacidade' element={<Privacidade />} />
          <Route path='/aprovacao/:id' element={<AprovacaoOrcamento />} />
          <Route path='*' element={<LandingPage />} />
        </Routes>

        <SessionExpiredPopup
          show={showSessionExpired}
          onClose={handleSessionExpiredClose}
        />
        <InactivityWarningPopup
          show={showInactivityWarning}
          onStay={handleInactivityStay}
          onLogout={handleInactivityLogout}
        />
      </>
    );
  }
  // ── END UNAUTHENTICATED LAYOUT ───────────────────────────────────────────

  return (
    <div className="App">
      <header className="App-header" style={{
          backgroundImage: `url(${bgHeader})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}>
          <div className='Browser'>
            <Link className='BrowserLink' to='/sidebar/Home'>
              <span className='desktop-only'>Início</span>
              <span className='mobile-only mobile-home' role='img' aria-label='Início' title='Início'>
                <svg className='home-svg' viewBox='0 0 24 24' width='28' height='28' xmlns='http://www.w3.org/2000/svg' role='img' aria-hidden='true'>
                  <circle cx='12' cy='12' r='12' fill='white' />
                  <path d='M12 3L2 11h3v8h6v-5h2v5h6v-8h3z' fill='rgb(235, 133, 0)' />
                </svg>
              </span>
            </Link>

            <div className={`dropdown-hover ${mobileMenuOpen ? 'open' : ''}`}>
              <Link className='BrowserLink' to='#' onClick={(e) => {
                if (window.innerWidth <= 768) {
                  e.preventDefault();
                  setMobileMenuOpen(!mobileMenuOpen);
                }
              }}>
                <span className='desktop-only'>Menu</span>
                <span className='mobile-only hamburger' role='img' aria-label='Menu' title='Menu'>
                  <svg viewBox='0 0 24 24' width='28' height='28' xmlns='http://www.w3.org/2000/svg' role='img' aria-hidden='true'>
                    <rect x='4' y='6' width='16' height='2' fill='#000' />
                    <rect x='4' y='11' width='16' height='2' fill='#000' />
                    <rect x='4' y='16' width='16' height='2' fill='#000' />
                  </svg>
                </span>
              </Link>
              <div className="dropdown-content">
                  {/* Quick link: Grupos (moved out of Estoque) */}
                  {/* Grupos link removed */}
                  {/* Novo submenu Cadastro */}
                  {(temPermissao('Cliente') || temPermissao('Fornecedor') || temPermissao('Pessoas')) && (
                  <div className={`submenu-hover ${openSubmenu === 'cadastro' ? 'open' : ''}`}>
                    <Link to="#" onClick={(e) => toggleSubmenu('cadastro', e)}>Cadastro</Link>
                    <div className="dropdown-submenu-content">
                      {temPermissao('Cliente') && <Link to="/sidebar/Cliente" onClick={() => setMobileMenuOpen(false)}>Cliente</Link>}
                      {temPermissao('Fornecedor') && <Link to="/sidebar/FornecedorDropdown" onClick={() => setMobileMenuOpen(false)}>Fornecedor</Link>}
                      {temPermissao('Pessoas') && <Link to="/sidebar/ResponsaveisDropdown" onClick={() => setMobileMenuOpen(false)}>Pessoas</Link>}
                    </div>
                  </div>
                  )}
                  {(temPermissao('Agendamentos') || temPermissao('Calendario') || temPermissao('Oportunidade') || temPermissao('Orcamento') || temPermissao('Vendas') || temPermissao('VendasProdutos')) && (
                  <div className={`submenu-hover ${openSubmenu === 'comercial' ? 'open' : ''}`}>
                    <Link to="#" onClick={(e) => toggleSubmenu('comercial', e)}>Comercial</Link>
                    {/* Comercial opens as a modal on mobile */}
                    <DropdownComercial onLinkClick={() => { setMobileMenuOpen(false); setOpenSubmenu(null); }} />
                  </div>
                  )}
                  {(temPermissao('Contrato') || temPermissao('ContasPagar') || temPermissao('ContasReceber') || temPermissao('NotaFiscal')) && (
                  <div className={`submenu-hover ${openSubmenu === 'financeiro' ? 'open' : ''}`}>
                    <Link to="#" onClick={(e) => toggleSubmenu('financeiro', e)}>Financeiro</Link>
                    {/* Financeiro opens as a modal on mobile */}
                    <DropdownFinanceiro onLinkClick={() => { setMobileMenuOpen(false); setOpenSubmenu(null); }} />
                  </div>
                  )}
                  {(temPermissao('Producao') || temPermissao('ProjetoVisual') || temPermissao('Tarefas') || temPermissao('MateriaPrima') || temPermissao('ServicosTerceiros')) && (
                  <div className={`submenu-hover ${openSubmenu === 'producao' ? 'open' : ''}`}>
                    <Link to="/sidebar/ProducoesDropdown" onClick={(e) => {
                      if (window.innerWidth <= 768) {
                        e.preventDefault();
                        toggleSubmenu('producao', e);
                      } else {
                        setMobileMenuOpen(false);
                        setOpenSubmenu(null);
                      }
                    }}>Projeto</Link>
                    <div className="dropdown-submenu-content">
                      {temPermissao('ProjetoVisual') && <Link to="/sidebar/ProjetoVisualDropdown" onClick={() => setMobileMenuOpen(false)}>Projeto Visual</Link>}
                      {temPermissao('Tarefas') && <Link to="/sidebar/TarefasProjetoDropdown" onClick={() => setMobileMenuOpen(false)}>Tarefas</Link>}
                      {temPermissao('MateriaPrima') && <Link to="/sidebar/MateriaPrimaDropdown" onClick={() => setMobileMenuOpen(false)}>Matéria Prima</Link>}
                      {temPermissao('ServicosTerceiros') && <Link to="/sidebar/ServicosTerceirosDropdown" onClick={() => setMobileMenuOpen(false)}>Serviços Terceiros</Link>}
                    </div>
                  </div>
                  )}
                  {(temPermissao('Manutencao') || temPermissao('Garantia')) && (
                  <div className={`submenu-hover ${openSubmenu === 'posproducao' ? 'open' : ''}`}>
                    <Link to="#" onClick={(e) => toggleSubmenu('posproducao', e)}>Pós-Projeto</Link>
                    <div className="dropdown-submenu-content">
                      {temPermissao('Manutencao') && <Link to="/sidebar/ManutencaoDropdown" onClick={() => setMobileMenuOpen(false)}>Manutenção</Link>}
                      {temPermissao('Garantia') && <Link to="/sidebar/GarantiaDropdown" onClick={() => setMobileMenuOpen(false)}>Garantia</Link>}
                    </div>
                  </div>
                  )}
                  {temPermissao('RelacionamentoClientes') && (
                  <div className={`submenu-hover ${openSubmenu === 'posvenda' ? 'open' : ''}`}>
                    <Link to="#" onClick={(e) => toggleSubmenu('posvenda', e)}>Pós-Venda</Link>
                    <div className="dropdown-submenu-content">
                      <Link to="/sidebar/RelacionamentoClientesDropdown" onClick={() => setMobileMenuOpen(false)}>Relacionamento com Clientes</Link>
                    </div>
                  </div>
                  )}
                  {(temPermissao('EntregasServicos') || temPermissao('EntregasProdutos')) && (
                  <div className={`submenu-hover ${openSubmenu === 'entregas' ? 'open' : ''}`}>
                    <Link to="#" onClick={(e) => toggleSubmenu('entregas', e)}>Entregas</Link>
                    <div className="dropdown-submenu-content">
                      {temPermissao('EntregasServicos') && <Link to="/sidebar/EntregaServicosDropdown" onClick={() => setMobileMenuOpen(false)}>Entregas de Serviços</Link>}
                      {temPermissao('EntregasProdutos') && <Link to="/sidebar/EntregasProdutosDropdown" onClick={() => setMobileMenuOpen(false)}>Entregas de Produtos</Link>}
                    </div>
                  </div>
                  )}
                  {temPermissao('Prazos') && (
                    <Link to="/sidebar/PrazosDropdown" onClick={() => { setMobileMenuOpen(false); setOpenSubmenu(null); }}>Prazos</Link>
                  )}
                  {(temPermissao('Produto') || temPermissao('Estoque')) && (
                  <div className={`submenu-hover ${openSubmenu === 'estoque' ? 'open' : ''}`}>
                    <Link to="#" onClick={(e) => toggleSubmenu('estoque', e)}>Estoque</Link>
                    <DropdownEstoque onLinkClick={() => { setMobileMenuOpen(false); setOpenSubmenu(null); }} />
                  </div>
                  )}
                  {/* link para cadastrar conta bancária removido do menu */}
                </div>
              </div>

            <div className='Logindiv'>
              {loggedIn ? (
                <div className='conta-dropdown-wrapper'>
                  <div style={{ cursor: 'pointer' }}>
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="11" fill="white" stroke="rgb(235, 133, 0)" strokeWidth="2"/>
                      <circle cx="12" cy="9" r="3.5" fill="rgb(235, 133, 0)"/>
                      <path d="M5.5 19.5c0-3.5 3-5.5 6.5-5.5s6.5 2 6.5 5.5" stroke="rgb(235, 133, 0)" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                  </div>
                  <DropdownConta onLinkClick={() => setMobileMenuOpen(false)} />
                </div>
              ) : (
                <Link className='Login' to='/sidebar/Login' onClick={() => setMobileMenuOpen(false)}>
                  <span className='desktop-only'>Login</span>
                  <span className='mobile-only' role='img' aria-label='login' title='Login'>👤</span>
                </Link>
              )}
            </div>
          </div>
        </header>

        <Routes>
            <Route path='/sidebar/Home' element={<Home />} />
            <Route path='/sidebar/Cliente' element={<Cliente />} />
            <Route path='/sidebar/Login' element={<Login />} />
            <Route path='/sidebar/AlterarSenha' element={<AlterarSenha />} />
            <Route path='/sidebar/MinhaConta' element={<MinhaConta />} />
            <Route path='/sidebar/Configuracoes' element={<Configuracoes />} />
            <Route path='/sidebar/Planos' element={<Planos />} />
            <Route path='/editar-cliente' element={<Sidebar />} />
            <Route path='/sidebar/ClientesDropdown' element={<ClientesDropdown />} />
            <Route path='/sidebar/AgendamentosDropdown' element={<AgendamentosDropdown />} />
            <Route path='/sidebar/CalendarioDropdown' element={<CalendarioDropdown />} />
            <Route path='/sidebar/ContasPagarDropdown' element={<ContasPagarDropdown />} />
            <Route path='/sidebar/ContasReceberDropdown' element={<ContasReceberDropdown />} />
            <Route path='/sidebar/EntregasProdutosDropdown' element={<EntregasProdutosDropdown />} />
            <Route path='/sidebar/EntregaServicosDropdown' element={<EntregaServicosDropdown />} />
            <Route path='/sidebar/PrazosDropdown' element={<PrazosDropdown />} />
            <Route path='/sidebar/FornecedorDropdown' element={<FornecedorDropdown />} />
            <Route path='/sidebar/GarantiaDropdown' element={<GarantiaDropdown />} />
            <Route path='/sidebar/NotaFiscalDropdown' element={<NotaFiscalDropdown />} />
            <Route path='/sidebar/CertificadoPlugNotasDropdown' element={<CertificadoPlugNotasDropdown />} />
            <Route path='/sidebar/GrupoDropDown' element={<GrupoDropDown />} />
            <Route path='/sidebar/MeusGruposDropdown' element={<MeusGruposDropdown />} />
            <Route path='/sidebar/OportunidadeDropdown' element={<OportunidadeDropdown />} />
            <Route path='/sidebar/OrcamentoDropdown' element={<OrcamentoDropdown />} />
            <Route path='/sidebar/ProducoesDropdown' element={<ProducoesDropdown />} />
            <Route path='/sidebar/DashboardProducao' element={<DashboardProducao />} />
            <Route path='/sidebar/RelacionamentoClientesDropdown' element={<RelacionamentoClientesDropdown />} />
            <Route path='/sidebar/ServicosTerceirosDropdown' element={<ServicosTerceirosDropdown />} />
            <Route path='/sidebar/VendasDropdown' element={<VendasDropdown />} />
            <Route path='/sidebar/VendasProdutosDropdown' element={<VendasProdutosDropdown />} />
            <Route path='/sidebar/ProdutoDropdown' element={<ProdutoDropdown />} />
            <Route path='/sidebar/EstoqueMaterialDropdown' element={<EstoqueMaterialDropdown />} />
            <Route path='/sidebar/ContratoDropdown' element={<ContratoDropdown />} />
            <Route path='/sidebar/ProjetoVisualDropdown' element={<ProjetoVisualDropdown />} />
            <Route path='/sidebar/TarefasProjetoDropdown' element={<TarefasProjetoDropdown />} />
            <Route path='/sidebar/MateriaPrimaDropdown' element={<MateriaPrimaDropdown />} />
            <Route path='/sidebar/ServicosTerceirosDropdown' element={<ServicosTerceirosDropdown />} />
            <Route path='/sidebar/ResponsaveisDropdown' element={<PessoasDropdown />} />
            <Route path='/sidebar/ManutencaoDropdown' element={<ManutencaoDropdown />} />
            <Route path='/sidebar/GarantiaDropdown' element={<GarantiaDropdown />} />
            <Route path='/sidebar/GestaoFinanceiraDropdown' element={<GestaoFinanceiraDropdown />} />
            <Route path='/sidebar/ResumoResponsaveisDropdown' element={<ResumoResponsaveisDropdown />} />
            <Route path='/sidebar/ResumoServicosTerceirosDropdown' element={<ResumoServicosTerceirosDropdown />} />
            <Route path='/sidebar/AutorizarNotaIndividual' element={<AutorizarNotaIndividual />} />
            <Route path='/sidebar/AutorizarNotaEmMassa' element={<AutorizarNotaEmMassa />} />
            <Route path='/sidebar/CancelarNota' element={<CancelarNota />} />
            <Route path='/sidebar/EditarNota' element={<EditarNota />} />

            <Route path='/sidebar/CriarConta' element={<CriarConta />} />
            <Route path='/sidebar/EsqueceuSenha' element={<EsqueceuSenha />} />
            <Route path='/sidebar/DadosUsuarios' element={<DadosUsuarios />} />
            <Route path='/sidebar/CadastrarConta' element={<CadastrarConta empresaId={userInfo?.empresaId} />} />
            <Route path='/sidebar/CadastrarUsuario' element={<CadastrarUsuario />} />
            <Route path='/sidebar/GerenciarFuncionarios' element={<GerenciarFuncionarios />} />
            <Route path='/sidebar/Funcionario' element={<Funcionario />} />
            <Route path='/sidebar/funcionario/:id' element={<Funcionario />} />
            <Route path='/minhas-conexoes' element={<MinhasConexoes />} />
      <Route path='/sidebar/ForumEmpresas' element={<ForumEmpresas />} />
          </Routes>
          
          {/* Popup de sessão expirada */}
          <SessionExpiredPopup 
            show={showSessionExpired} 
            onClose={handleSessionExpiredClose} 
          />

          {/* Popup de aviso de inatividade (1 hora) */}
          <InactivityWarningPopup
            show={showInactivityWarning}
            onStay={handleInactivityStay}
            onLogout={handleInactivityLogout}
          />

          {/* Badge de countdown de inatividade (desativado, manter para uso futuro)
          {loggedIn && inactivitySecsLeft !== null && (
            <div style={{
              position: 'fixed',
              bottom: 24,
              left: '50%',
              transform: 'translateX(-50%)',
              background: inactivitySecsLeft <= 10 ? '#d32f2f' : 'rgb(235, 133, 0)',
              color: 'white',
              borderRadius: 50,
              padding: '10px 28px',
              fontWeight: 700,
              fontSize: 18,
              fontFamily: 'monospace',
              zIndex: 88000,
              boxShadow: '0 4px 16px rgba(0,0,0,0.35)',
              pointerEvents: 'none',
              transition: 'background 0.3s',
              whiteSpace: 'nowrap'
            }}>
              ⏱ Inatividade: {String(Math.floor(inactivitySecsLeft / 60)).padStart(2,'0')}:{String(inactivitySecsLeft % 60).padStart(2,'0')}
            </div>
          )}
          */}

          {/* Ajuda Widget global */}
          {loggedIn && <AjudaWidget />}

          {/* Chat Widget global */}
          {loggedIn && <ChatWidget />}

          {/* Mobile Footer - visible only on mobile/tablet */}
          {loggedIn && (
            <MobileFooter
              onOpenAjuda={() => window.dispatchEvent(new Event('open-ia-chat'))}
              onOpenChat={() => window.dispatchEvent(new Event('open-chat-widget'))}
            />
          )}
    </div>
  );
}

// Componente principal que envolve com o Provider
function App() {
  return (
    <HomologGate>
      <PermissoesProvider>
        <AppContent />
      </PermissoesProvider>
    </HomologGate>
  );
}

export default App;

